import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { COLLECTIONS_ROUTE, RENDERS_PREVIEWS_ROUTE_V2 } from '../constants/routePathConstants';

export function useSwitchOrgToggle(initialValue = false) {
  const navigate = useNavigate();
  const [state, setState] = useState(initialValue);
  const [loadPage, setLoadPage] = useState(false);

  const switchOrgToggle = () => {
    setState((prevState) => !prevState);
  };

  useEffect(() => {
    !loadPage && setLoadPage(true);
    // This effect runs when any data is updated
    // However, we only want to execute some code when it's not the initial render
    if (state !== initialValue) {
      // Put your code here that you want to run when data is updated but not initially
      window.$restrictFilter = null;
      let url = window.$previousURL;
      if (url && url?.match(COLLECTIONS_ROUTE)?.length) {
        url = COLLECTIONS_ROUTE;
      }
      navigate(url || RENDERS_PREVIEWS_ROUTE_V2);
    }
  }, [state, initialValue]);

  return [loadPage, switchOrgToggle];
}
